import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
export const LoaderContainer = styled(ContentLoader) `
  width: ${({ $hasButton }) => ($hasButton ? '15.6' : '12.8')}rem;
  height: ${({ $hasDesc }) => ($hasDesc ? '6.5' : '4.7')}rem;
`;
export const CurrencyInputContainer = styled.div `
  width: ${({ hasButton }) => (hasButton ? '15.6' : '12.8')}rem;
  height: ${({ hasDesc }) => (hasDesc ? '6.5' : '4.7')}rem;
`;
export const ButtonLoader = styled.rect `
  height: 1.6rem;
  width: 3rem;

  y: 1.3rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;
export const SelectLoader = styled.rect `
  height: 4.3rem;
  width: ${({ hasButton }) => (hasButton ? '12' : '12.8')}rem;

  x: ${({ hasButton }) => (hasButton ? 'calc(100% - 12rem)' : 'initial')};

  rx: 2.2rem;
  ry: 2.2rem;
`;
export const DescLoader = styled.rect `
  height: 1.6rem;
  width: 100%;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: calc(100% - 1.6rem);
`;
//# sourceMappingURL=styles.js.map